import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import FaqList from 'common/components/faqs';

const How2 = ({ title, titleBackground, steps }) => {
  return (
    <div className="block block-how-2">
      <section className={classnames("block block-title text-center", titleBackground)}>
        <h2>{ title || "How crowdspring works..." }</h2>
      </section>

      { steps.map((step, i) => (
      <section className={classnames(`block how-step step-${i + 1}`, step.background)} key={i}>
        <div className="row">
          <div className="columns small-16 large-7 large-offset-1">
            <h3 className="step-title">
              <span className="number">{i + 1}.</span>{ step.title }
            </h3>
            { step.subtitle && <h3 className="subtitle">{ step.subtitle }</h3> }
            <ul className="step-features">
              { step.features.map((feat, i) => (
                <li key={i}><i className="fa fa-long-arrow-right"/>{ feat }</li>
              )) }
            </ul>
            <div className="faqs">
              <h3>{ step.faqsTitle || 'FAQs' }</h3>
              <FaqList data={step.faqs} />
            </div>
            { !step.testimonialCentered && !!step.testimonial &&
            <div className="testimonial">
              <div className="quote">"{ step.testimonial.quote }"</div>
              <div className="author">
                <img src={step.testimonial.avatar} /> { step.testimonial.author }
              </div>
            </div> }
          </div>
          <div className="columns small-16 large-7">
            <div className="artwork-container">
              <img alt={step.image.alt} src={step.image.src} />
            </div>
          </div>
        </div>

        { step.testimonialCentered && !!step.testimonial &&
        <div className="row columns">
          <div className="testimonial centered">
            <div className="quote">"{ step.testimonial.quote }"</div>
            <div className="author">
              <img src={step.testimonial.avatar} /> { step.testimonial.author }
            </div>
          </div>
        </div> }

        { step.option &&
        <div className="row">
          <div className="columns small-16 large-7 large-offset-1">
            <div className="artwork-container">
              <img alt={step.option.image.alt} src={step.option.image.src} />
            </div>
          </div>
          <div className="columns small-16 large-7">
            <h3 className="subtitle">{ step.option.title }</h3>
            <ul className="step-features">
              { step.option.features.map((feat, i) => (
                <li key={i}><i className="fa fa-long-arrow-right"/>{ feat }</li>
              )) }
            </ul>
            <div className="faqs">
              <h3>{ step.option.faqsTitle || 'FAQs' }</h3>
              <FaqList data={step.option.faqs} />
            </div>
            { !!step.option.testimonial &&
            <div className="testimonial">
              <div className="quote">"{ step.option.testimonial.quote }"</div>
              <div className="author">
                <img src={step.option.testimonial.avatar} /> { step.option.testimonial.author }
              </div>
            </div> }
          </div>
        </div> }

        { step.option &&
        <div className="row columns text-center consultation-row">
          <h3>Not sure which is right for you?</h3>
          <Link to="/help/contact/consultation/" className="btn btn-text btn-lg">
            Get a free design consultation <i className="fa fa-long-arrow-right" />
          </Link>
        </div> }
      </section>
      )) }
    </div>
  );
};

export default How2;



// WEBPACK FOOTER //
// ./landing_pages/components/how_2.jsx